import { BREAKPOINTS_MEDIA as a } from "./breakpoints.js";
import { spacing as t } from "./spacing.js";
import { outline as m } from "./outline.js";
import { fade as s } from "./fade.js";
import { expandElementOverOffset as n, scrollableFlexEdgeElementMargins as l } from "./offscreenScrollStyles.js";
import { overlayedBackground as p } from "./overlayedBackground.js";
import { hover as d } from "./hover.js";
import { inheritIconColor as h } from "./icons.js";
import { badgesTheme as f } from "./components/badges.js";
import { buttonsTheme as c } from "./components/buttons.js";
import { cards as x } from "./components/cards.js";
import { collapsibleTheme as b } from "./components/collapsible.js";
import { dialogsTheme as g } from "./components/dialogs.js";
import { dropdownsTheme as u } from "./components/dropdowns.js";
import { checkboxesTheme as y } from "./components/forms/checkbox.js";
import { forms as T } from "./components/forms/forms.js";
import { inputsTheme as v } from "./components/forms/input.js";
import { radioButtonTheme as w } from "./components/forms/radio.js";
import { switchesTheme as k } from "./components/forms/switch.js";
import { textAreaTheme as A } from "./components/forms/textArea.js";
import { linksTheme as S } from "./components/links.js";
import { segmentedControlsTheme as E } from "./components/segmentedControl.js";
import { separatorsTheme as I } from "./components/separator.js";
import { skeletonsTheme as O } from "./components/skeletons.js";
import "./components/tags.js";
import { textTheme as W } from "./components/text.js";
import { toastsTheme as C } from "./components/toast.js";
import { tooltipsTheme as F } from "./components/tooltips.js";
const M = 4, i = new Array(151).fill(void 0).map((r, e) => e * M), se = {
  breakpoints: a,
  sizes: i,
  space: i,
  spacing: t,
  overlayedBackground: p,
  fade: s,
  expandElementOverOffset: n,
  scrollableFlexEdgeElementMargins: l,
  hover: d,
  inheritIconColor: h,
  fontSizes: {
    xs: 12,
    sm: 13,
    md: 16,
    lg: 20,
    xl: 24,
    h4: 28,
    h3: 36,
    h2: 60,
    h1: 80
  },
  colors: {
    white: "#ffffff",
    primary: "#000000",
    primaryAccent: "#1A1A1A",
    secondary: "#f5f5f7",
    secondaryText: "#86868b",
    lightGray3: "#e4e4e4",
    mediumGray3: "#333333",
    disabledText: "#86868b",
    stroke: "#f2f2f2",
    success: "#7dc64e",
    sustainability: "#44d62c",
    accent: "#b779f4",
    error: "#FF6464",
    selectedBorder: "#C2C2C5",
    screenOverlay: "rgba(0, 0, 0, 0.3)",
    cardOverlay: "rgba(0, 0, 0, 0.04)",
    transparent40: "rgba(0, 0, 0, 0.4)"
  },
  fonts: {
    main: "var(--font-main)"
  },
  fontWeights: {
    regular: 400,
    bold: 700
  },
  lineHeights: {
    label: "16px",
    label2: "20px",
    body: "24px",
    headline2: "22px",
    headline1: "32px",
    title4: "24px",
    title3: "32px",
    title2: "48px",
    title1: "72px",
    largeTitle: "96px"
  },
  letterSpacings: {
    largeTitle: "-0.02em",
    smallcaps: "0.04em"
  },
  radii: { xs: 4, sm: 8, md: 12, lg: 16, xl: 20, xxl: 24, xxxl: 40 },
  zIndices: {
    cardOverlay: 1,
    controllers: 2,
    feedNavigation: 3,
    pageHeader: 4,
    mobilePageHeader: 5,
    dialogOverlay: 10,
    dropdownMenu: 100,
    story: 1e3,
    configuratorOverlay: 1e5,
    toastViewport: 1e5
  },
  shadows: {
    sm: "0px 2px 16px rgba(0, 0, 0, 0.04)",
    md: "0px 4px 25px rgba(0, 0, 0, 0.08)",
    lg: "0px 10px 40px rgba(0, 0, 0, 0.08)"
  },
  borders: {
    "thin-stroke": "1px solid var(--theme-ui-colors-stroke)",
    "thin-secondary": "1px solid var(--theme-ui-colors-secondary)",
    "thin-white": "1px solid var(--theme-ui-colors-white)"
  },
  border(r, e) {
    var o;
    return `${t(r)} solid ${((o = this.colors) == null ? void 0 : o[e]) ?? e}`;
  },
  outline: m,
  inheritWidth: {
    maxWidth: ["inherit", "inherit", "inherit"],
    minWidth: ["inherit", "inherit", "inherit"]
  },
  absoluteFill: {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    borderRadius: "inherit",
    overflow: "hidden"
  },
  hideScrollbarStyles: {
    scrollbarWidth: "none",
    msOverflowStyle: "none",
    "&::-webkit-scrollbar": {
      display: "none"
    }
  },
  hideInputNumberArrows: {
    "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
      WebkitAppearance: "none",
      margin: 0
    },
    "input[type=number]": {
      MozAppearance: "textfield"
    }
  },
  transitions: {
    all: "all 0.3s ease",
    default: "0.3s ease"
  },
  styles: {
    root: {
      fontFamily: "main",
      color: "primary",
      bg: "white",
      WebkitTapHighlightColor: "transparent",
      WebkitFontSmoothing: "antialiased",
      "ol, ul": {
        m: 0,
        paddingInlineStart: 0,
        listStylePosition: "inside"
      },
      // by default all radix dialogs are set to `modal: true` mode by setting `pointer-events: none`
      // to body to comply with accessibility requirements
      // when Stripe 3d-secure modal (with nested iframe) appears on top of radix dialog it has pointer-events
      // blocked so this simple hack makes Stripe test modal available to interaction
      iframe: {
        pointerEvents: "auto"
      },
      // the same hack as above, but to make LastPass work with Radix Dialogs
      "div[data-lastpass-root]": {
        pointerEvents: "auto"
      }
    },
    a: {
      color: "primary",
      textDecoration: "none",
      cursor: "pointer",
      "&:hover, &:active": {
        textDecoration: "underline"
      }
    },
    hr: {
      color: "stroke"
    }
  },
  cards: x,
  forms: T,
  ...W,
  ...c,
  ...k,
  ...O,
  ...y,
  ...w,
  ...b,
  ...I,
  ...E,
  ...C,
  ...F,
  ...v,
  ...A,
  ...g,
  ...u,
  ...f,
  ...S
};
export {
  M as SIZE_MULTIPLIER,
  se as baseTheme
};
